
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 bg-[#5C1A24]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
          Transforme seu projeto em um investimento de alto valor.
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Entre em contato conosco e descubra como podemos transformar sua visão em realidade 
          com a excelência técnica e criativa que você merece.
        </p>
        <Link 
          to="/contato"
          className="inline-block px-8 py-3 bg-white text-[#5C1A24] font-semibold rounded-lg cursor-pointer whitespace-nowrap hover:bg-gray-100 transition-colors"
        >
          Fale conosco
        </Link>
      </div>
    </section>
  );
}
